// extracted by mini-css-extract-plugin
export default {"innerWrapper":"yz-z","tooltipWrapper":"zz-z","icon":"Az-z","tooltip":"Bz-z","content":"Cz-z"};